import service from '@/services/vehicle/VehicleService'

export const vehicleModule = {
  strict: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state: {
    vehicleList: [],
    vehicle: {},
    loadingItems: false,
    pagination: {
      current_page: 1,
      last_page: 1,
      per_page: 15,
    },
    headerList: [],
  },
  mutations: {
    SETVEHICLELIST(state, payload) {
      state.vehicleList = payload.data
      state.pagination.current_page = payload.current_page
      state.pagination.last_page = payload.last_page
      state.headerList = []
    },
    SETVEHICLE(state, payload) {
      state.vehicle = payload
    },
    SET_LOADING(state) {
      state.loadingItems = !state.loadingItems
    },
  },

  actions: {
    async getVehicles({ commit }, payload) {
      try {
        commit('SET_LOADING')
        const response = await service.getVehicles(payload)
        commit('SETVEHICLELIST', response)
      } finally {
        commit('SET_LOADING')
      }
    },
    async getVehicle({ commit }, payload) {
      try {
        commit('SET_LOADING')
        const response = await service.getVehicle(payload)
        commit('SETVEHICLE', response)
        return response
      } finally {
        commit('SET_LOADING')
      }
    },
    async updateVehicle({ commit, dispatch, state }, payload) {
      try {
        commit('SET_LOADING')
        const form = { ...payload.form }
        const { status } = await service.update(form, payload.id)

        dispatch('getVehicles', { page: state.pagination.current_page })

        return status
      } finally {
        commit('SET_LOADING')
      }
    },
    async insertVehicle({ commit, dispatch, state }, payload) {
      try {
        commit('SET_LOADING')
        const { status } = await service.insert(payload)

        dispatch('getVehicles', { page: state.pagination.current_page })

        return status
      } finally {
        commit('SET_LOADING')
      }
    },
    async deleteVehicle({ dispatch, state }, payload) {
      const { status } = await service.delete(payload)
      dispatch('getVehicles', { page: state.pagination.current_page })
      return status
    },
  },
}
